export default "__VITE_ASSET__CDOLbl4e__"